<template>
  <!--弹框3 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameToolongDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter">
      <div style="width:100%;text-align: center;">
        <div><img src="/static/img/frame/toolong.png" class="frame-big-img" @click="refresh"></div>
        <div class="frame-text-hotel-sold wordBreak">
          <div v-html="$t('youBeenThisPageForeTooLongTime')"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="booknow_button" style="float: none; width: auto;" @click="cityRouterLink">Home</el-button>
      </span>
    </el-dialog>
  </div>
  <!--弹框3 结束-->
  <!--引入方式-->
  <!-- <frameToolong :frameToolongDialog="frameToolongDialog"></frameToolong> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameToolong',
  props: ['frameToolongDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: ''
    }
  },
  created () {
    var query = this.$route.query
    if (JSON.stringify(query) !== '{}') {
      this.adult = parseInt(this.$route.query.adult)
      this.child = parseInt(this.$route.query.child)
      this.room = parseInt(this.$route.query.room)

      this.startdate = this.$route.query.start_date
      this.enddate = this.$route.query.end_date
    } else {
      var params = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      if (JSON.stringify(params) !== '{}' || (searchData !== '{}' && searchData !== null)) {
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.start_date
        this.enddate = params.end_date
      }
    }
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    refresh () {
      location.reload()
      this.frameToolongDialog = false
    },
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.$route.query
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.$route.query.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
      })
    },
    // 城市跳转
    cityRouterLink: function () {
      // 点击返回首页 埋点记录
      this.clickPageAction('back_home', '', {'type': 'frameToolong'})

      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }

      var date1 = new Date()
      date1.setDate(date1.getDate())
      var date2 = new Date(date1)
      date2.setDate(date1.getDate() + 1)
      var startDate = this.startdate
      if (this.startdate === '' || this.startdate === undefined) {
        startDate = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
      }
      var endDate = this.enddate
      if (this.enddate === '' || this.enddate === undefined) {
        endDate = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
      }

      var childNums = '[]'
      var searchData = localStorage.getItem('searchData')
      if (searchData !== '{}' && searchData !== null) {
        var params = JSON.parse(searchData)
        childNums = params.childNums
      }
      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': this.room, 'adult': this.adult, 'child': this.child, 'childNums': childNums}
      localStorage.setItem('searchData', JSON.stringify(searchJson))
      this.$router.push({name: 'HotelList', query: searchJson})
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:40px; font-size: 16px;color: #4F4C4C;text-align: center;margin-top: 10px;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameToolong.vue